import React from "react";

const Washing_31 = React.forwardRef(
  ({ width = "33", height = "24", viewBox = "0 0 33 24", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30.1867 2H6.54386V0H32.1867V24H0L0.201196 22.8305L0.202334 22.8239L0.204887 22.8094L0.214293 22.7573C0.222493 22.7125 0.234579 22.6479 0.250695 22.5653C0.282919 22.4002 0.331303 22.1629 0.397001 21.8683C0.528261 21.2797 0.729353 20.4588 1.00983 19.5249C1.56513 17.6758 2.45424 15.3052 3.77718 13.4246C6.56153 9.46668 11.0131 8.5 19.3682 8.5C23.5686 8.5 26.5395 8.59307 28.4653 8.68666C29.1797 8.72138 29.7504 8.75618 30.1867 8.78634V2ZM30.1867 10.7913C29.7505 10.7601 29.1487 10.7222 28.3682 10.6843C26.4776 10.5924 23.5393 10.5 19.3682 10.5C10.9804 10.5 7.55299 11.5333 5.41296 14.5754C4.27372 16.1948 3.45865 18.3242 2.92532 20.1001C2.70682 20.8277 2.53942 21.4828 2.41843 22H30.1867V10.7913Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Washing_31;
